import React from 'react';
import { Box, Typography, useMediaQuery, Link } from '@mui/material';
import locationIcon from '../../../assets/icons/location.png';
import clock from '../../../assets/icons/clock.png';
import phone from '../../../assets/icons/phone.png';
import email from '../../../assets/icons/email.png';
import facebookIcon from '../../../assets/icons/facebookIcon.png';
import theme from '../../../theme';

const ShopLocationInformation = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const contactNumbers = [
    "09678782020",
    "09788788539",
    "09404040677",
  ];
  const viberNumbers = ["09678782020", "09788788539"];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: isMobile ? "10px" : "12px",
      }}
    >
      <Box
        sx={{
          width: isMobile ? "100%" : "70%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
          }}
        >
          <img src={locationIcon} alt="Location icon" style={{ width: 20, objectFit: 'contain' }} />
          <Typography
            sx={{
              fontSize: isMobile ? "10px" : "16px",
              fontFamily: `'Roboto', sans-serif`,
              color: theme.palette.text.secondary,
              lineHeight: "1.7",
            }}
          >
            အမှတ် ၁၀၈ ၊ ၂၅ လမ်း ၊ ၈၃ လမ်းနှင့် ၈၄ လမ်းကြား ၊ မန္တလေးမြို့။
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
          }}
        >
          <img src={clock} alt="Clock icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography sx={{ color: theme.palette.primary.text, fontSize: isMobile ? "10px" : "16px" }}>
            ဖွင့်ချိန် မနက် ၉ နာရီ - ပိတ်ချိန် ညနေ ၅ နာရီ
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
            flexWrap: "wrap",
          }}
        >
          <img src={phone} alt="Phone icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography
            sx={{
              fontSize: isMobile ? "10px" : "16px",
              color: "#515151",
            }}
          >
            Contact Numbers:{" "}
            {contactNumbers.map((number, index) => (
              <React.Fragment key={number}>
                <Link
                  href={`tel:${number}`}
                  sx={{ color: "#515151", textDecoration: "none", '&:hover': { textDecoration: "underline" } }}
                >
                  {number}
                </Link>
                {index < contactNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
            flexWrap: "wrap",
          }}
        >
          <img src={phone} alt="Viber icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography
            sx={{
              fontSize: isMobile ? "10px" : "16px",
              color: "#515151",
            }}
          >
            Viber:{" "}
            {viberNumbers.map((number, index) => (
              <React.Fragment key={number}>
                <Link
                  href={`viber://chat?number=${number}`}
                  sx={{ color: "#515151", textDecoration: "none", '&:hover': { textDecoration: "underline" } }}
                >
                  {number}
                </Link>
                {index < viberNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
            flexWrap: "wrap",
          }}
        >
          <img src={locationIcon} alt="Map icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link
            href="https://www.google.com/maps/place/21%C2%B059'05.0%22N+96%C2%B004'41.4%22E/@21.984726,96.07817,17z/data=!3m1!4b1!4m4!3m3!8m2!3d21.984726!4d96.07817!17m2!4m1!1e3!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDIwMS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#515151", textDecoration: "none", '&:hover': { textDecoration: "underline" } }}
          >
            Map Link
          </Link>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
            flexWrap: "wrap",
          }}
        >
          <img src={email} alt="Email icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link
            href="mailto:masterrazorblade2023@gmail.com"
            sx={{ color: "#515151", textDecoration: "none", '&:hover': { textDecoration: "underline" } }}
          >
            masterrazorblade2023@gmail.com
          </Link>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            textAlign: "left",
            flexWrap: "wrap",
          }}
        >
          <img src={facebookIcon} alt="Facebook icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link
            href="https://www.facebook.com/share/1N5jqAVVFu/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#515151", textDecoration: "none", '&:hover': { textDecoration: "underline" } }}
          >
            facebook.com/share/1N5jqAVVFu
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default ShopLocationInformation;
